<ng-template #addressDetails let-address="address" let-i="index" let-isSelected="isSelected">
  <div class="mat-body-2 text text-content mb-2" id="checkout_view_address_list_item{{ i }}-address">
    <div class="address-list-item__address_title">
      {{ addressTitleKey | translate }}
    </div>
    <div class="address-list-item__recipient_details mb-6" id="checkout_view_address_list_item{{ i }}_recipient_name">
      {{ address?.recipient_name }}
    </div>

    @if (isSelected && address?.recipient_phone_number) {
    <div class="address-list-item__recipient_details mb-6" id="checkout_view_address_list_item{{ i }}_phone">
      {{ address?.recipient_phone_number }}
    </div>
    }

    <div class="address-list-item__recipient_details mb-6" id="checkout_view_address_list_item{{ i }}_street">
      {{ [address?.street_number, address?.street_name, address?.apartment].join(' ').trim() }}
    </div>

    @if (isSelected && address?.rural_postal_address) {
    <div class="address-list-item__recipient_details mb-6" id="checkout_view_address_list_item{{ i }}_address_rural">
      {{ address?.rural_postal_address }}
    </div>
    }

    <div class="address-list-item__city_province_postal mb-6">
      <span id="checkout_view_address_list_item{{ i }}_city_province">
        {{ [address?.city, address?.province].join(', ').trim() }}
      </span>
      @if (isSelected) {
      <span id="checkout_view_address_list_item{{ i }}_country">
        {{ address?.country }}
      </span>
      }
      <span id="checkout_view_address_list_item{{ i }}_postal_code">
        {{ formatPostalCode(address?.postal_code) }}
      </span>
    </div>
  </div>
</ng-template>

<ng-template #addressMenu let-address="address" let-i="index">
  @if (showMenuButton) {
  <pbb-menu
    style="align-self: center"
    (click)="$event.stopPropagation()"
    [menuTitleKey]="addressTitleKey"
    [reverseButtonIcon]="true"
    id="address_item{{ i }}_menu"
    idLabel="address_item{{ i }}"
    menuAriaLabel="{{ [address?.street_number, address?.street_name, address?.apartment].join(' ').trim() }}"
    [options]="options"
    [item]="address"
    [itemRef]="address.shipping_address_ref"
    [openDesktopDialog]="true"
    [itemIndex]="i"
    (menuAction)="menuAction.emit($event)"
  ></pbb-menu>
  }
</ng-template>

<ng-template #addressDefault let-address="address">
  @if (defaultShippingAddressRef === address.shipping_address_ref) {
  <div class="default-chip">
    <mat-chip-listbox [attr.aria-label]="'ARIA_LABEL.ADDRESS_FLAGS' | translate">
      <mat-basic-chip
        class="default-chip primary-chip"
        id="address-list_default-chip"
        [attr.aria-label]="'ARIA_LABEL.DEFAULT_ADDRESS' | translate"
      >
        <mat-icon [attr.aria-label]="'ARIA_LABEL.CHECK_CIRCLE' | translate">check_circle</mat-icon>
        <div class="mat-caption">{{ 'COMMON.DEFAULT' | translate }}</div>
      </mat-basic-chip>
    </mat-chip-listbox>
  </div>
  }
</ng-template>

@if(!selectable) {
<mat-list>
  @for (address of addresses; track $index; let i = $index) {
  <mat-list-item
    id="checkout_view_address_list_item{{ i }}"
    [class.selected-address]="selectable && selectedShippingAddressRef === address.shipping_address_ref"
  >
    <div class="flex-row">
      <ng-container *ngTemplateOutlet="addressDetails; context: { address: address, index: i }"></ng-container>
      <div class="flex-col">
        <ng-container *ngTemplateOutlet="addressMenu; context: { address: address, index: i }"></ng-container>
      </div>
    </div>
    <ng-container *ngTemplateOutlet="addressDefault; context: { address: address, index: i }"></ng-container>
  </mat-list-item>
  }
</mat-list>
} @else {
<mat-radio-group
  [(ngModel)]="selectedShippingAddressRef"
  (ngModelChange)="clickAddress($event)"
  class="radio-button-list"
>
  @for (address of addresses; track $index; let i = $index) {
  <div class="pbb-address-list-item-wrapper">
    <div
      class="flex-col pbb-address-list-item"
      [class.selected]="address.shipping_address_ref === selectedShippingAddressRef"
    >
      <div class="flex-row width-100">
        <pbb-radio
          [id]="'checkout_view_address_list_item' + i"
          labelPosition="before"
          [value]="address.shipping_address_ref"
          [checked]="address.shipping_address_ref === selectedShippingAddressRef"
          [cssClass]="'mat-body-2 background-transparent flex-label-radio'"
        >
          <ng-container
            *ngTemplateOutlet="
              addressDetails;
              context: {
                address: address,
                index: i,
                isSelected: address.shipping_address_ref === selectedShippingAddressRef
              }
            "
          ></ng-container>
        </pbb-radio>
        <div class="flex-row">
          <div class="pbb-address-list-item-options">
            <ng-container *ngTemplateOutlet="addressMenu; context: { address: address, index: i }"></ng-container>
            <ng-container *ngTemplateOutlet="addressDefault; context: { address: address, index: i }"></ng-container>
          </div>
        </div>
      </div>
      @if (address.shipping_address_ref === selectedShippingAddressRef && $any(address)?.delivery_instructions) {
      <div
        class="address-list-item__delivery_instructions"
        id="checkout_view_address_list_item{{ i }}_delivery_instructions"
      >
        {{ $any(address)?.delivery_instructions }}
      </div>
      }
    </div>
  </div>
  }
</mat-radio-group>
}
